export const REDUCER_KEY_AI_SEARCH_SUMMARY = 'aiSearchSummary';

export const SUMMARY_STATUS = {
  NOT_REQUESTED: 'NOT_REQUESTED',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const SUMMARY_POLLING_INTERVAL = 2000;
export const SUMMARY_POLLING_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};

export const SET_SUMMARY_STATUS = 'SET_SUMMARY_STATUS';
export const SET_SUMMARY_RESPONSE = 'SET_SUMMARY_RESPONSE';
export const SET_SUMMARY_ERROR = 'SET_SUMMARY_ERROR';
export const RESET_SUMMARY_STATE = 'RESET_SUMMARY_STATE';
